import { render, staticRenderFns } from "./GenericEditDialog.vue?vue&type=template&id=7af62e6e&lang=pug"
import script from "./GenericEditDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenericEditDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports